import React, { useState, useEffect } from 'react';
import { dataApi } from "../../apis/dataApi";
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import '../../css/fonts.css'
import '../../css/style.css'
import '../../css/bootstrap@5.3.0.min.css'

import bg from '../../assets/Walpapers/Wallpaper.png';
import kidzos from '../../assets/Iconos/kidzos.png';
import card from '../../assets/Iconos/card.png';
import { useTranslation } from 'react-i18next';
import LogoCam from '../../assets/Logotipo/Logo_cetesninos_color.png';
import { useNavigate } from 'react-router-dom';


function Detalle() {

    // Hide print buttons when printing
    const printHideStyle = `
@media print {
  .btn-cetesJunior {
    display: none !important;
  }
}
`;

    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [isLoading, setIsLoading] = useState(false);
    // Read all query params directly
    const id = searchParams.get('id') || '';
    const date = searchParams.get('date') || '';
    const name = searchParams.get('name') || '';
    const selectedOption = searchParams.get('selectedOption') || '';
    const percentage = searchParams.get('percentage') || '';
    const yieldI = searchParams.get('yieldI') || '';
    const timeInit = searchParams.get('timeInit') || '';
    const timeEnd = searchParams.get('timeEnd') || '';
    const selectedOptionT = searchParams.get('selectedOptionT') || '';
    const total = searchParams.get('total') || '';


    const handleClickEnd = (e) => {
        e.preventDefault();
        navigate(`/Finalizar`);
    }
    const handleClick = (e) => {
        e.preventDefault();
        window.print();
    }

    return (
        <>
            <style>{printHideStyle}</style>
            <div className="cetes-background" style={{ backgroundImage: `url(${bg})` }}>
                <div className="cetes-background-inner">
                    <div className="cetes-junior-header">
                        <div className="info-header-cetes-junior">
                            <div className="text-header-cetes">
                                <h4 className="text-header-mayus">{t('resumen_title')}<b>{t('resumen_title_bold')}</b></h4>
                            </div>
                        </div>
                        <div className="logo_CETES_junior">
                            <div className="logo logo-cetes">
                                <img src={LogoCam} alt="Logo organización KidZania" />
                            </div>
                        </div>
                    </div>
                    {/* <div class="">
                    <div class="item-ttl white-color">
                        <h4 style={{ textAlign: "left" }}>{t('resumen_title_name')}: <b>Carlos</b></h4>
                    </div>
                </div> */}
                    <div className="registro-content_">
                        <div className="table-resumen-cetes">
                            <div className="datos-relevantes-cetes">
                                <div className="item-ttl">
                                    <h4>{t('summary_summary')} <span> {t('summary_operation')}</span> </h4>
                                </div>
                            </div>
                            <div className="container-resumenGrafico-cetes" style={{ textAlign: "right" }}>
                                <div className="item-table-resumen">
                                    <div className="text-ttl-inner-resumenGrafico">
                                        <p>{t('summary_id')}:</p>
                                    </div>
                                    <div className="txt-valor-resumenGrafico" style={{ textAlign: "left", marginLeft: "10px" }}>
                                        <p>{id}</p>
                                    </div>
                                </div>
                                <div className="item-table-resumen">
                                    <div className="text-ttl-inner-resumenGrafico">
                                        <p>{t('summary_date')}:</p>
                                    </div>
                                    <div className="txt-valor-resumenGrafico" style={{ textAlign: "left", marginLeft: "10px" }}>
                                        <p>{date}</p>
                                    </div>
                                </div>
                                <div className="item-table-resumen">
                                    <div className="text-ttl-inner-resumenGrafico">
                                        <p>{t('summary_name')}:</p>
                                    </div>
                                    <div className="txt-valor-resumenGrafico" style={{ textAlign: "left", marginLeft: "10px" }}>
                                        <p>{name}</p>
                                    </div>
                                </div>
                                <div className="item-table-resumen">
                                    <div className="text-ttl-inner-resumenGrafico">
                                        <p>{t('summary_investmentAmount')}:</p>
                                    </div>
                                    <div className="txt-valor-resumenGrafico" style={{ textAlign: "left", marginLeft: "10px" }}>
                                        <p>{selectedOption} kidZos</p>
                                    </div>
                                </div>
                                <div className="item-table-resumen">
                                    <div className="text-ttl-inner-resumenGrafico">
                                        <p>{t('summary_yield')}:</p>
                                    </div>
                                    <div className="txt-valor-resumenGrafico" style={{ textAlign: "left", marginLeft: "10px" }}>
                                        <p>{percentage}%</p>
                                    </div>
                                </div>
                                <div className="item-table-resumen">
                                    <div className="text-ttl-inner-resumenGrafico">
                                        <p>{t('symmary_yieldText')}:</p>
                                    </div>
                                    <div className="txt-valor-resumenGrafico" style={{ textAlign: "left", marginLeft: "10px" }}>
                                        <p>{yieldI} kidZos</p>
                                    </div>
                                </div>
                                <div className="item-table-resumen">
                                    <div className="text-ttl-inner-resumenGrafico">
                                        <p>{t('summary_investmentStart')}:</p>
                                    </div>
                                    <div className="txt-valor-resumenGrafico" style={{ textAlign: "left", marginLeft: "10px" }}>
                                        <p>{timeInit}</p>
                                    </div>
                                </div>
                                <div className="item-table-resumen">
                                    <div className="text-ttl-inner-resumenGrafico">
                                        <p>{t('summary_investmentEnd')}:</p>
                                    </div>
                                    <div className="txt-valor-resumenGrafico" style={{ textAlign: "left", marginLeft: "10px" }}>
                                        <p>{timeEnd}</p>
                                    </div>
                                </div>
                                <div className="item-table-resumen">
                                    <div className="text-ttl-inner-resumenGrafico">
                                        <p>{t('summary_investmentTime')}:</p>
                                    </div>
                                    <div className="txt-valor-resumenGrafico" style={{ textAlign: "left", marginLeft: "10px" }}>
                                        <p>{selectedOptionT} {t('summary_minutes')}</p>
                                    </div>
                                </div>
                                <div className="item-table-resumen">
                                    <div className="text-ttl-inner-resumenGrafico">
                                        <p>{t('summary_finalBalance')}:</p>
                                    </div>
                                    <div className="txt-valor-resumenGrafico" style={{ textAlign: "left", marginLeft: "10px" }}>
                                        <p>{total} kidZos</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="registro-form-cetes-inner">
                        <div className="btn-cetesJunior" style={{ marginTop: "50px" }} >
                            <button type="submit" onClick={handleClick} style={{ float: 'right', marginLeft: "50px" }}>{t('detail_print_button')} </button>
                            <button type="submit" onClick={handleClickEnd} style={{ float: 'right' }}>{t('detail_end_button')} </button>

                        </div>
                    </div>
                </div>
                {isLoading ? (
                    <div className="loading">
                        <div className="spinner"></div>
                    </div>
                ) : (
                    <div>
                        {/* Resto del código */}
                    </div>
                )}
            </div>
        </>
    );
}



export default Detalle;